<template>
  <v-card>
    <Snackbar :textError="textError" :isSnackbar="isSnackbar" />
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      v-model="selected"
      show-select
      :headers="this.headers"
      :items="this.values"
      :search="search"
      :items-per-page="20"
      :footer-props="{
        'items-per-page-text': 'Filas por página',
        'items-per-page-options': [20, 30, 50, 100, -1],
      }"
      :custom-filter="dataTableCustomSearch"
    >
      <template v-slot:item.amount="{ item }">
        {{ formatAmount(item.amount) }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          x-small
          color="primary"
          :to="`/convenios/` + item.id"
          target="_blank"
        >
          <v-icon small>mdi-eye</v-icon>
        </v-btn>
        <v-btn
          x-small
          color="error"
          @click="confirmDeleteItem(item)"
          v-if="
            getCanDelete ||
            (item && getUserData && item.promoter === getUserData.id)
          "
        >
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <PreviewPdf :isDialog="dialog" :url="url" @closeDialog="closePdfPreview" />
    <v-row justify="center">
      <v-dialog v-model="dialogConfrim" persistent max-width="390">
        <v-card>
          <v-card-title class="text-h6" style="word-break: break-word">
            ¿Está seguro que quiere eliminar el Convenio?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialogConfrim = false">
              Cancelar
            </v-btn>
            <v-btn
              color="red darken-1"
              text
              @click="deleteContract(selectedContradtId)"
            >
              Si
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-snackbar
      v-if="selected.length"
      v-model="selected"
      :timeout="-1"
      color="primary"
    >
      Exportar {{ selected.length }} elementos
      <v-btn
        color="secondary"
        @click.native="exportToCSV(selected, 'data.csv', headers)"
        >Descargar</v-btn
      >
    </v-snackbar>
  </v-card>
</template>

<script>
import formatters from "@/utils/formatters.js";
import PreviewPdf from "@/components/PreviewPdf.vue";
import services from "@/services/services";
import Snackbar from "@/components/Snackbar";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ConveniosTable",
  props: ["headers", "values"],
  components: {
    Snackbar,
    PreviewPdf,
  },
  data() {
    return {
      selected: [],
      search: "",
      textError: null,
      isSnackbar: false,
      dialog: false,
      url: "",
      dialogConfrim: false,
      degreeOfExecution: null,
      hasInvoices: null,
      selectedContradtId: null,
    };
  },
  methods: {
    ...mapActions(["setActionsLoader"]),
    getPromoter(id) {
      let promoter = this.getObjectById("users", id);
      return promoter ? `${promoter.name} ${promoter.surname}` : "";
    },

    // customSearch(value, search, item) {
    //   // return Object.values(item).some(
    //   //   (v) => v && v.toString().toLowerCase().includes(search.toLowerCase())
    //   // );
    //   return (
    //     item.searchFieldsText &&
    //     item.searchFieldsText.toLowerCase().includes(search.toLowerCase())
    //   );
    // },
    formatAmount(amount) {
      return formatters.amountFormatter.format(Number(amount));
    },
    deleteContract(id) {
      this.setActionsLoader(true);
      services
        .deleteData("convenios", id)
        .then(() => {
          this.setActionsLoader(false);
          this.textError = null;
          this.isSnackbar = true;
          this.dialogConfrim = false;
        })
        .catch((e) => {
          console.error(e);
          this.setActionsLoader(false);
          this.textError = "Algo salió mal. Por favor, vuelva a intentarlo";
          this.isSnackbar = true;
          this.dialogConfrim = false;
        });
    },
    confirmDeleteItem(item) {
      this.dialogConfrim = true;
      this.selectedContradtId = item.id;
    },
    openPdfPreview(url) {
      this.url = url;
      this.dialog = true;
    },
    closePdfPreview() {
      this.dialog = false;
    },
    getPath(type) {
      if (type === "Marco") {
        return "cecontract";
      } else {
        return "cecontract";
      }
    },
  },
  computed: {
    ...mapGetters([
      "getObjectById",
      "getCanDelete",
      "getUserData",
      "getInvoices",
    ]),
  },
};
</script>

<style>
.clickable {
  cursor: pointer;
}
</style>
